<template>
    <div>
        <input
            type="text"
            :placeholder="$t('components.core.days-modal-picker.placeholder')"
            v-model="readableSelection"
            @click="showArrivalDaysModal = true"
        />
        <core-modal
            v-if="showArrivalDaysModal"
            @close="showArrivalDaysModal = false"
            isAbsolute
        >
            <div slot="body">
                <core-days-picker :days.sync="selectedDays"></core-days-picker>
            </div>
        </core-modal>
    </div>
</template>

<script>
export default {
  data () {
    return {
      showArrivalDaysModal: false,
      daysList: [
        'components.core.days-modal-picker.monday',
        'components.core.days-modal-picker.tuesday',
        'components.core.days-modal-picker.wednesday',
        'components.core.days-modal-picker.thursday',
        'components.core.days-modal-picker.friday',
        'components.core.days-modal-picker.saturday',
        'components.core.days-modal-picker.sunday'
      ],
      selectedDays: this.days
    }
  },
  props: {
    days: {
      default: '000000',
      type: String,
      required: false
    }
  },
  computed: {
    readableSelection () {
      let selection = []
      for (let key in this.selectedDays) {
        if (this.selectedDays[key] === '1') {
          selection.push(this.$t(this.daysList[key]))
        }
      }
      return selection
    }
  },
  methods: {
    check (index) {
      let arrivalDays = this.selectedDays.split('')
      return arrivalDays[index] === '1'
    },
    toggleDay (e, index) {
      let days = this.selectedDays.split('')
      days[index] = (e.target.checked) ? '1' : '0'
      this.selectedDays = days.join('')
    }
  },
  watch: {
    selectedDays (val) {
      this.$emit('update:days', val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/DaysModalPicker.vue